import { Endpoints } from 'UI/constants/endpoints';

import { sendRequest } from './utils';

const title = 'Candidates';

/**
 * @param {number} candidateId
 * @param {*} data
 * @param {*} options
 * @returns {Promise<OperationResult>}
 */
export const sendReferenceReleaseEmail = async (candidateId, data, options) =>
  sendRequest(
    `${Endpoints.Candidates}/${candidateId}/${Endpoints.ReferenceReleases}`,
    'post',
    data,
    options?.successBody || 'The email was sent successfully',
    options?.successTitle || title
  );

/**
 * @param {number} companyId
 * @param {*} data
 * @param {*} options
 * @returns {Promise<OperationResult>}
 */
export const addHiringAuthority = async (companyId, data, options) =>
  sendRequest(
    `${Endpoints.Companies}/${companyId}/${Endpoints.HiringAuthorities}`,
    'post',
    data,
    options?.successBody || 'Hiring Authority added successfully',
    options?.successTitle || title
  );

/**
 * @param {string} url
 * @param {*} data
 * @param {*} options
 * @returns {Promise<OperationResult>}
 */
export const LinkHiringAuthorityOrCandidate = async (url, data, options) =>
  sendRequest(url, 'post', data, options?.successBody, options?.successTitle);
